import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import ownerDocument from './utils/ownerDocument';
import getContainer from './utils/getContainer';
import { componentOrElement } from '../../wui-core/src';
var isReact16 = ReactDOM.createPortal !== undefined;
var createPortal = isReact16 ? ReactDOM.createPortal : ReactDOM.unstable_renderSubtreeIntoContainer;
var propTypes = {
  /**
   * 存放子组件的容器
   */
  container: PropTypes.oneOfType([componentOrElement, PropTypes.func])
};
var defaultProps = {};
/**
 * Portal组件是将子组件渲染
 */

var Portal = /*#__PURE__*/function (_Component) {
  _inherits(Portal, _Component);

  var _super = _createSuper(Portal);

  function Portal(props) {
    var _this;

    _classCallCheck(this, Portal);

    _this = _super.call(this, props);
    _this.getMountNode = _this.getMountNode.bind(_assertThisInitialized(_this));
    _this.getOverlayDOMNode = _this.getOverlayDOMNode.bind(_assertThisInitialized(_this));
    _this.mountOverlayTarget = _this.mountOverlayTarget.bind(_assertThisInitialized(_this));
    _this.unmountOverlayTarget = _this.unmountOverlayTarget.bind(_assertThisInitialized(_this));
    _this.renderOverlay = _this.renderOverlay.bind(_assertThisInitialized(_this));
    _this.unrenderOverlay = _this.unrenderOverlay.bind(_assertThisInitialized(_this));
    _this.overlayTarget = isReact16 ? document.createElement('div') : null;
    return _this;
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (isReact16) {
        this.portalContainerNode = getContainer(this.props.container, ownerDocument(this).body);
        this.portalContainerNode.appendChild(this.overlayTarget);
      } else {
        this.renderOverlay();
      }

      this.mounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (isReact16) {
        var overlay = !this.props.children ? null : React.Children.only(this.props.children);

        if (overlay === null) {
          this.unrenderOverlay();
          this.unmountOverlayTarget();
        } else {}
      } else {
        this.renderOverlay();
      }
    } //this._overlayTarget为当前的要添加的子组件， this._portalContainerNode要添加组件的容器元素

  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.overlayTarget && nextProps.container !== this.props.container) {
        this.portalContainerNode.removeChild(this.overlayTarget);
        this.portalContainerNode = getContainer(nextProps.container, ownerDocument(this).body);
        this.portalContainerNode.appendChild(this.overlayTarget);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unrenderOverlay();
      this.unmountOverlayTarget();
      this.mounted = false;
    }
  }, {
    key: "getMountNode",
    value: function getMountNode() {
      return this.overlayTarget;
    }
  }, {
    key: "getOverlayDOMNode",
    value: function getOverlayDOMNode() {
      if (!this.mounted) {
        throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
      }

      if (this.overlayInstance) {
        return ReactDOM.findDOMNode(this.overlayInstance);
      }

      return null;
    }
    /**
     * 如果要添加的子组件不存在，就将div添加到要添加容器的DOM中；
     */

  }, {
    key: "mountOverlayTarget",
    value: function mountOverlayTarget() {
      if (!this.overlayTarget) {
        this.overlayTarget = document.createElement('div');
        this.portalContainerNode = getContainer(this.props.container, ownerDocument(this).body);
        this.portalContainerNode.appendChild(this.overlayTarget);
      }
    }
    /**
     * 将要添加的子元素从容器中移除，并把变量置为null
     */

  }, {
    key: "unmountOverlayTarget",
    value: function unmountOverlayTarget() {
      if (this.overlayTarget) {
        this.portalContainerNode.removeChild(this.overlayTarget);
        this.overlayTarget = null;
      }

      this.portalContainerNode = null;
    }
    /**
     * 手动渲染_overlayTarget
     */

  }, {
    key: "renderOverlay",
    value: function renderOverlay() {
      var overlay = !this.props.children ? null : React.Children.only(this.props.children); // Save reference for future access.

      if (overlay !== null) {
        this.mountOverlayTarget();
        this.overlayInstance = ReactDOM.unstable_renderSubtreeIntoContainer(this, overlay, this.overlayTarget);
      } else {
        // Unrender if the component is null for transitions to null
        this.unrenderOverlay();
        this.unmountOverlayTarget();
      }
    }
    /**
     * 销毁_overlayTarget组件。并把_overlayInstance置为null
     */

  }, {
    key: "unrenderOverlay",
    value: function unrenderOverlay() {
      if (this.overlayTarget) {
        !isReact16 && ReactDOM.unmountComponentAtNode(this.overlayTarget);
        this.overlayInstance = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!isReact16) {
        return null;
      }

      var overlay = !this.props.children ? null : React.Children.only(this.props.children);
      return /*#__PURE__*/ReactDOM.createPortal(overlay, this.overlayTarget);
    }
  }]);

  return Portal;
}(Component);

;
Portal.propTypes = propTypes;
Portal.defaultProps = defaultProps;
export default Portal;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-overlay/src/Portal.js